<div
  class="container-fluid w-100 h-100 d-flex flex-column justify-content-center align-items-center"
>
  <div class="d-flex flex-column align-items-center justify-content-center">
    <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
  </div>
  <div class="header-5 loader-text">
    {{ text }}
  </div>
</div>
